import { useTranslation } from 'react-i18next';

interface PendingBadgeProps {
  count: number;
  isSyncing: boolean;
}

export function PendingBadge({ count, isSyncing }: Readonly<PendingBadgeProps>) {
  const { t } = useTranslation();

  if (count === 0 && !isSyncing) {
    return null;
  }

  return (
    <span
      role="status"
      aria-live="polite"
      aria-label={t('offline.pendingLabel')}
      className="inline-flex items-center rounded-full bg-yellow-100 px-2.5 py-0.5 text-xs font-medium text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200"
    >
      {isSyncing ? t('offline.syncing') : t('offline.pendingCount', { count })}
    </span>
  );
}
